<template>


    <section class="py-8 w-full bg-white md:py-16 md:-mt-28">
        <div class="px-4 mx-auto max-w-6xl xl:px-12 2xl:px-4">

            <!-- Intro links -->
            <div class="xl:text-xl font-ww-regular">
                <strong> Congrats - as your order of Mindflow is preparing, I have a suggestion...</strong>
                <br> <br>
                There’s one problem most first-time buyers run into…
                <br> <br>
                They run out just as the mental magic starts to build.
            </div>

            <!-- Title -->
            <h2 class="mt-8 mb-6 text-3xl font-extrabold text-center lg:mt-16 lg:mb-10 md:text-4xl xl:text-42 font-ww-bold">
                Why Another 6 Bags Is a Brain-Smart Move
            </h2>

            <!-- Comparison boxes -->
            <div class="grid gap-6 md:grid-cols-2">

                <!-- Without this upsell -->
                <div class="flex flex-col mx-auto w-full h-full">
                    <!-- header bar -->
                    <div class="lg:py-6 py-3 font-bold text-center bg-[#FEB4C7] font-ww-medium xl:text-xl text-lg">
                        Without This Upsell
                    </div>

                    <!-- content -->
                    <div class="bg-[#FBF9F6] lg:px-10 px-4 lg:py-8 py-4 text-sm leading-relaxed flex-1">
                        <ul class="space-y-3">
                            <li
                                class="flex gap-3 items-start text-base font-ww-regular xl:text-xl md:text-lg !leading-6">
                                <div class="mt-1">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="10" cy="10" r="10" fill="#F1574B" />
                                        <path d="M6 6L14 14" stroke="white" stroke-width="1.2" />
                                        <path d="M14 6L6 14" stroke="white" stroke-width="1.2" />
                                    </svg>
                                </div>

                                <span>Risk running out in less than 3 months and losing momentum</span>
                            </li>
                            <li
                                class="flex gap-3 items-start text-base font-ww-regular xl:text-xl md:text-lg !leading-6">
                                <div class="mt-1">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="10" cy="10" r="10" fill="#F1574B" />
                                        <path d="M6 6L14 14" stroke="white" stroke-width="1.2" />
                                        <path d="M14 6L6 14" stroke="white" stroke-width="1.2" />
                                    </svg>
                                </div>

                                <span>Pay full price later ($36 / bag) + shipping</span>
                            </li>
                            <li
                                class="flex gap-3 items-start text-base font-ww-regular xl:text-xl md:text-lg !leading-6">
                                <div class="mt-1">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="10" cy="10" r="10" fill="#F1574B" />
                                        <path d="M6 6L14 14" stroke="white" stroke-width="1.2" />
                                        <path d="M14 6L6 14" stroke="white" stroke-width="1.2" />
                                    </svg>
                                </div>

                                <span>Start-and-stop habit (inconsistent benefits)</span>
                            </li>
                            <li
                                class="flex gap-3 items-start text-base font-ww-regular xl:text-xl md:text-lg !leading-6">
                                <div class="mt-1">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="10" cy="10" r="10" fill="#F1574B" />
                                        <path d="M6 6L14 14" stroke="white" stroke-width="1.2" />
                                        <path d="M14 6L6 14" stroke="white" stroke-width="1.2" />
                                    </svg>
                                </div>

                                <span>Could get brain fog again</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <!-- With this upsell -->
                <div class="flex flex-col mx-auto w-full h-full">
                    <!-- header bar -->
                    <div class="lg:py-6 py-3 font-bold text-center bg-[#D2F06F] font-ww-medium xl:text-xl text-lg">
                        With This Upsell
                    </div>

                    <!-- content -->
                    <div class="bg-[#FBF9F6] lg:px-10 px-4 lg:py-8 py-4 text-sm leading-relaxed flex-1">
                        <ul class="space-y-3">
                            <li
                                class="flex gap-3 items-start text-base font-ww-regular xl:text-xl md:text-lg !leading-6">
                                <div class="mt-1">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="10" cy="10" r="10" fill="#C4E538" />
                                        <path
                                            d="M8.72222 13.0278L6.08333 10.3889C5.97222 10.2778 5.97222 10.0833 6.08333 9.94444L6.5 9.52778C6.61111 9.41667 6.80556 9.41667 6.94444 9.52778L8.94444 11.5278L13.3889 7.08333C13.5 6.97222 13.6944 6.97222 13.8333 7.08333L14.25 7.5C14.3611 7.61111 14.3611 7.80556 14.25 7.94444L9.16667 13.0278C9.02778 13.1389 8.83333 13.1389 8.72222 13.0278Z"
                                            fill="black" />
                                    </svg>
                                </div>

                                <span>Stay in the Growth Zone for 8 months — no “gap weeks”</span>
                            </li>
                            <li
                                class="flex gap-3 items-start text-base font-ww-regular xl:text-xl md:text-lg !leading-6">
                                <div class="mt-1"> 
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="10" cy="10" r="10" fill="#C4E538" />
                                        <path
                                            d="M8.72222 13.0278L6.08333 10.3889C5.97222 10.2778 5.97222 10.0833 6.08333 9.94444L6.5 9.52778C6.61111 9.41667 6.80556 9.41667 6.94444 9.52778L8.94444 11.5278L13.3889 7.08333C13.5 6.97222 13.6944 6.97222 13.8333 7.08333L14.25 7.5C14.3611 7.61111 14.3611 7.80556 14.25 7.94444L9.16667 13.0278C9.02778 13.1389 8.83333 13.1389 8.72222 13.0278Z"
                                            fill="black" />
                                    </svg>
                                </div>

                                <span>Instant $100+ in savings and we cover the shipping</span>
                            </li>
                            <li
                                class="flex gap-3 items-start text-base font-ww-regular xl:text-xl md:text-lg !leading-6">
                                <div class="mt-1">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="10" cy="10" r="10" fill="#C4E538" />
                                        <path
                                            d="M8.72222 13.0278L6.08333 10.3889C5.97222 10.2778 5.97222 10.0833 6.08333 9.94444L6.5 9.52778C6.61111 9.41667 6.80556 9.41667 6.94444 9.52778L8.94444 11.5278L13.3889 7.08333C13.5 6.97222 13.6944 6.97222 13.8333 7.08333L14.25 7.5C14.3611 7.61111 14.3611 7.80556 14.25 7.94444L9.16667 13.0278C9.02778 13.1389 8.83333 13.1389 8.72222 13.0278Z"
                                            fill="black" />
                                    </svg>
                                </div>

                                <span>Daily nutrient saturation—key nootropics can work better with time</span>
                            </li>
                            <li
                                class="flex gap-3 items-start text-base font-ww-regular xl:text-xl md:text-lg !leading-6">
                                <div class="mt-1">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="10" cy="10" r="10" fill="#C4E538" />
                                        <path
                                            d="M8.72222 13.0278L6.08333 10.3889C5.97222 10.2778 5.97222 10.0833 6.08333 9.94444L6.5 9.52778C6.61111 9.41667 6.80556 9.41667 6.94444 9.52778L8.94444 11.5278L13.3889 7.08333C13.5 6.97222 13.6944 6.97222 13.8333 7.08333L14.25 7.5C14.3611 7.61111 14.3611 7.80556 14.25 7.94444L9.16667 13.0278C9.02778 13.1389 8.83333 13.1389 8.72222 13.0278Z"
                                            fill="black" />
                                    </svg>
                                </div>

                                <span>Focus becomes your new normal</span>
                            </li>
                        </ul>
                    </div>
                </div>

            </div>
        </div>
    </section>


</template>